var _rect, _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCatePersonal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 7,
    fill: "#F0E0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18393 10.4375C7.425 10.4375 6 11.9961 6 13.9199C6 14.2402 6.2375 14.5 6.53036 14.5H13.4696C13.7625 14.5 14 14.2402 14 13.9199C14 11.9961 12.575 10.4375 10.8161 10.4375H9.18393Z",
    fill: "#A855F7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 7.25,
    r: 2.25,
    fill: "#A855F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCatePersonal);
export default __webpack_public_path__ + "static/media/icon-cate-personal.806fe40967869fb09b02b0d3196d42f8.svg";
export { ForwardRef as ReactComponent };